<template>
    <sections>
        <section-contact heading="Contact" content="<article-contact />"></section-contact>
    </sections>
</template>

<script setup>
const $config = useRuntimeConfig();
useSeo().buildHead({
    title: 'Contact | ' + $config.public.siteName,
    description: "We'd love to hear about your project.",
    index: true,
});
</script>
